<template>
  <v-row>
    <v-col md="12">
      <ModuleHeader>Reporte Monedero</ModuleHeader>
    </v-col>
    <v-col md="12" cols="12">
      <v-card>
        <v-card-text>
          <v-row>
            <v-col md="6" cols="12">
              <v-autocomplete
                v-model="selectedGroup"
                :items="grupos"
                prepend-icon="mdi-view-list"
                outlined
                dense
                color="blue-grey lighten-2"
                label="Grupos Cliente"
                item-text="name"
                item-value="name"
              >
              </v-autocomplete>
            </v-col>
            <v-col md="6" cols="12">
              <v-autocomplete
                v-model="selectedClient"
                :items="data_clientes"
                @change="handleSelectChange"
                prepend-icon="mdi-account"
                outlined
                dense
                chips
                multiple
                color="blue-grey lighten-2"
                label="Cliente"
                item-text="NombreCompleto"
                item-value="Id"
              >
              </v-autocomplete>
            </v-col>
            <v-col class="text-right" md="12" cols="12">
              <v-btn @click="processMovimientosMonederos()" color="red" dark
                >Generar PDF</v-btn
              >
              <v-btn @click="exportExcel()" class="mx-1" color="success" dark
                >Generar Excel</v-btn
              >
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<style></style>

<script>
import { clone } from "lodash";
import pdfmake from "pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
pdfmake.vfs = pdfFonts.pdfMake.vfs;
import ReporteMonederos from "../../../clases/PdfMakers/ReporteMonederos.js";
import Cliente from "../../../clases/Cliente.js";
import moment from "moment";
import MonederosExcel from "../../../clases/ExcelMaker/MonederosExcel.js";
export default {
  name: "ReporteMonedero",
  components: {},
  props: [],
  data() {
    return {
      //data_clientes:[],
      selectedGroup: "TODOS",
      selectedClient: ["ALL"],
      grupos: [],
      movimientos: [],
      config: {
        selectableRow: true,
        selectConfig: {
          idRowData: "Id", // id necesario para indicar id unico del row que esta seleccionado y retornarlo en los eventos requeridos
        },
        orderByCol: { Field: "", Type: "Asc" },
        buttons: [],
        fields: [
          {
            title: "Apellidos",
            dataName: "Apellidos",
            text: "Nombre",
            value: "NombreCompleto",
          },

          {
            title: "Total Monedero",
            dataName: "Monedero",
            text: "Total Monedero",
            value: "SaldoMonedero",
            format: (row) => {
              let text = row["Monedero"]
                ? this.$pgsHelper.formatNumber(row["Monedero"].Saldo) + " P"
                : "Sin monedero";
              return text;
            },
          },

          {
            title: "Total MXN",
            dataName: "Monedero",
            text: "Total MXN",
            value: "SaldoMonedero",
            format: (row) => {
              let text = row["Monedero"]
                ? this.$pgsHelper.formatNumber(row["SaldoConversion"]) + " MXN"
                : "Sin monedero";
              return text;
            },
          },
        ],
      },
    };
  },
  methods: {
    handleSelectChange() {
      if (
        this.selectedClient.includes("ALL") &&
        this.selectedClient.some((item) => item !== "ALL")
      ) {
        // Si "ALL" está seleccionado junto con otros, elimina "ALL" y deja los otros
        let lengthSelected = this.selectedClient.length;
        if (this.selectedClient[lengthSelected - 1] == "ALL") {
          this.selectedClient = ["ALL"];
        } else {
          this.selectedClient = this.selectedClient.filter(
            (item) => item !== "ALL"
          );
        }
      } else if (this.selectedClient.length === 0) {
        // Si no hay selecciones, agrega "ALL"
        this.selectedClient = ["ALL"];
      }
    },
    async getUserGroups() {
      const firestore = this.$store.getters.getFirebaseApp.firestore;
      var data = await firestore.queryBuilder("PDV_GruposCliente", [
        firestore.where(
          "Tenant",
          "==",
          this.$store.getters.getFirebaseApp.tenant
        ),
      ]);

      let document = data.docs.map((doc) => {
        return { id: doc.ref.id, ...doc.data() };
      });

      let gps = [{ name: "TODOS" }];
      if (document) {
        document.forEach((doc) => {
          if (doc.gps) {
            let grupos = Object.entries(doc.gps);
            grupos.forEach((element) => {
              if (element[1]) {
                gps.push({
                  name: element[0],
                });
              }
            });
          }
        });
      }
      this.grupos = gps;
    },
    async getMovimientosMonedero() {
      let movimientos = [];
      const firestore = this.$store.getters.getFirebaseApp.firestore;
      var data = await firestore.queryBuilder("PDV_Monedero_Movimientos", [
        firestore.where(
          "Tenant",
          "==",
          this.$store.getters.getFirebaseApp.tenant
        ),
      ]);
      let document = data.docs.map((doc) => {
        return { id: doc.ref.id, ...doc.data() };
      });
      this.movimientos = document;
    },
    async processMovimientosMonederos() {
      await this.getMovimientosMonedero();
      let clientesMonedero = [];
      let clientesFilters = this.data_clientes;
      if (this.selectedGroup != "TODOS") {
        clientesFilters = this.$pgsHelper.filterBy(
          clientesFilters,
          "tipo",
          this.selectedGroup
        );
      }
      if (!this.selectedClient.includes("ALL")) {
        clientesFilters = clientesFilters.filter((item) =>
          this.selectedClient.includes(item.Id)
        );
      }
      clientesFilters.forEach((cliente) => {
        let movimientos = this.$pgsHelper.filterBy(
          this.movimientos,
          "Cliente",
          cliente.Id
        );
        if (movimientos.length > 0) {
          let orderedMovs = this.orderMovimientos(movimientos);
          cliente.MovimientosMonedero = orderedMovs;
          clientesMonedero.push(this.$pgsHelper.cloneObj(cliente));
        }
      });
      let mainData = {
        FG: new moment().format("DD/MM/YYYY"),
        HG: new moment().format("HH:mm:ss"),
        data: clientesMonedero,
        TITLE: "MONEDEROS",
      };
      let docData = ReporteMonederos.getDocData(mainData);
      pdfmake.createPdf(docData).open();
    },
    async exportExcel() {
      await this.getMovimientosMonedero();
      let clientesMonedero = [];
      let clientesFilters = this.data_clientes;
      if (this.selectedGroup != "TODOS") {
        clientesFilters = this.$pgsHelper.filterBy(
          clientesFilters,
          "tipo",
          this.selectedGroup
        );
      }
      if (!this.selectedClient.includes("ALL")) {
        clientesFilters = clientesFilters.filter((item) =>
          this.selectedClient.includes(item.Id)
        );
      }
      clientesFilters.forEach((cliente) => {
        let movimientos = this.$pgsHelper.filterBy(
          this.movimientos,
          "Cliente",
          cliente.Id
        );
        if (movimientos.length > 0) {
          let orderedMovs = this.orderMovimientos(movimientos);
          cliente.MovimientosMonedero = orderedMovs;
          clientesMonedero.push(this.$pgsHelper.cloneObj(cliente));
        }
      });
      MonederosExcel.generateExcelBuffer(clientesMonedero)
        .then((buffer) => {
          const blob = new Blob([buffer], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.download = `MONEDEROS.xlsx`;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
        })
        .catch((err) => {
          console.error("Error exportando a Excel:", err);
        });
    },
    orderMovimientos(mov) {
      let movimientos = [];
      let OrderDocs = this.$_.orderBy(mov, ["Crat"], ["asc"]);
      OrderDocs.forEach((doc, indexDoc) => {
        let withoutInitialcharge = doc.Movimientos.filter(
          (mov) => mov.Descripcion != "Creacion Monedero"
        );
        withoutInitialcharge.forEach((mov, index) => {
          mov.Cliente = this.nombre;
          mov.Index = Number(indexDoc + "" + index);
          movimientos.push(mov);
        });
      });
      let orderMovs = this.$_.orderBy(
        movimientos,
        ["Fecha", "Index"],
        ["asc", "asc"]
      );
      let saldoAnterior = 0;

      orderMovs.forEach((mov) => {
        mov.SaldoAnterior = saldoAnterior;
        if (mov._Op == "D") {
          saldoAnterior = saldoAnterior + mov.Cantidad;
        } else {
          saldoAnterior = saldoAnterior - mov.Cantidad;
        }
        mov.SaldoPosterior = saldoAnterior;
      });
      //this.movimientos = orderMovs
      return this.$_.orderBy(orderMovs, ["Fecha", "Index"], ["desc", "desc"]);
    },
    dtButtonClick(buttonId, idSelected) {
      if (buttonId == "movimientosMonedero") {
        this.formIndex++;
        this.editMode = true;
        let prodEdit = this.$pgsHelper.getById(
          this.monederos,
          "Id",
          idSelected[0]
        );
        this.editData = prodEdit;
        this.showModal = true;
      }
      if (buttonId == "deleteCupon") {
        this.deleteCupon(idSelected[0]);
      }
    },
  },
  computed: {
    data_clientes() {
      let clientes = [{ Id: "ALL", NombreCompleto: "TODOS" }];
      let rowclientes = Cliente.getClientsList();
      rowclientes.forEach((cliente) => {
        if (cliente.Id != "PUBLICOGENERAL") {
          cliente.SaldoConversion = cliente.Monedero
            ? cliente.Monedero.Saldo
            : 0;
          cliente.SaldoConversion = cliente.SaldoConversion * 1;
          cliente.NombreCompleto = cliente.Nombres + " " + cliente.Apellidos;
          clientes.push(cliente);
        }
      });

      return clientes;
    },
  },
  watch: {},
  mounted() {
    this.getUserGroups();
  },
  created() {},
};
</script>
